// Every language is listed under its own name - Cesky, English - in all translations, never
// translated into the language currently selected. A user who landed in a language they cannot
// read has to be able to find their own in the switch. The locale.* keys therefore carry the
// same endonym in every file under assets/i18n and are used nowhere else in the app.
export const AVAILABLE_LANGUAGES = [
  { name: 'locale.cs', id: 'cs' },
  { name: 'locale.en', id: 'en' },
]

export const DEFAULT_LANGUAGE = 'cs'

export function getSupportedLanguage(language?: string | null): string {
  const languageId = language?.toLowerCase().split('-')[0]
  if (languageId && AVAILABLE_LANGUAGES.some(availableLanguage => availableLanguage.id === languageId)) {
    return languageId
  }

  return DEFAULT_LANGUAGE
}
